import { ThemeColors } from "../../shared/data/types";
import {
  green,
  blue,
  amber,
  orange,
  red,
  grey,
  indigo,
  purple,
  deepPurple,
  teal,
  lime,
  lightGreen,
  cyan,
  deepOrange,
  brown,
} from "@material-ui/core/colors";

export const getThemeHexColor = (
  themeColor: ThemeColors | string
): { light: string; dark: string } => {
  switch (themeColor) {
    case "amber":
      return { light: amber[700], dark: amber[800] };

    case "blue":
      return { light: blue[700], dark: blue[800] };

    case "brown":
      return { light: brown[700], dark: brown[800] };

    case "cyan":
      return { light: cyan[700], dark: cyan[800] };

    case "deepOrange":
      return { light: deepOrange[700], dark: deepOrange[800] };

    case "deepPurple":
      return { light: deepPurple[700], dark: deepPurple[800] };

    case "green":
      return { light: green[700], dark: green[800] };

    case "grey":
      return { light: grey[700], dark: grey[800] };

    case "indigo":
      return { light: indigo[700], dark: indigo[800] };

    case "lightGreen":
      return { light: lightGreen[700], dark: lightGreen[800] };

    case "lime":
      return { light: lime[700], dark: lime[800] };

    case "orange":
      return { light: orange[700], dark: orange[800] };

    case "purple":
      return { light: purple[700], dark: purple[800] };

    case "red":
      return { light: red[700], dark: red[800] };

    case "teal":
      return { light: teal[700], dark: teal[800] };

    default:
      return { light: themeColor, dark: themeColor };
  }
};
